<div id="layout-wrapper">

  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar></app-sidebar>

  <div class="main-content">
    <main class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </main>

    <!-- footer -->
    <app-footer></app-footer>
  </div>
</div>